module.exports = __webpack_public_path__ + "static/media/italylog.f963ef68.png";